export default __webpack_public_path__ + "static/media/circle_purple.f7af207c.svg";